import { render } from "./dispatch-add.vue?vue&type=template&id=52ce45a5&scoped=true&ts=true"
import script from "./dispatch-add.vue?vue&type=script&lang=ts"
export * from "./dispatch-add.vue?vue&type=script&lang=ts"

import "./dispatch-add.vue?vue&type=style&index=0&id=52ce45a5&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ce45a5"]])

export default __exports__